import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Countdown timer pentru lansarea publica (beta -> public launch).
 * Inlocuieste textul static "BETA PRIVATA" din counter banner.
 *
 * Target date hardcodat — schimba dupa nevoie.
 */
const BETA_END_DATE = new Date('2026-07-01T00:00:00Z');

export default function BetaCountdown() {
  const { t } = useTranslation();
  const [time, setTime] = useState(getTimeLeft());

  useEffect(() => {
    const id = setInterval(() => setTime(getTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  if (time.total <= 0) {
    return (
      <div style={{ fontSize: 14, color: '#92400E', fontFamily: 'DM Mono, monospace' }}>
        <strong style={{ color: '#0A1428', fontSize: 16 }}>{t('app.beta_countdown.closed')}</strong> · {t('app.beta_countdown.accepting_public')}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: '#92400E', fontFamily: 'DM Mono, monospace' }}>
      <strong style={{ color: '#0A1428', fontSize: 14 }}>BETA</strong>
      <span>{t('app.beta_countdown.closes_in')}</span>
      <div style={{ display: 'inline-flex', gap: 6, alignItems: 'baseline' }}>
        <Unit value={time.days} label={t('app.beta_countdown.unit_days')} />
        <Unit value={time.hours} label={t('app.beta_countdown.unit_hours')} />
        <Unit value={time.minutes} label={t('app.beta_countdown.unit_minutes')} />
        <Unit value={time.seconds} label={t('app.beta_countdown.unit_seconds')} />
      </div>
    </div>
  );
}

function Unit({ value, label }) {
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'baseline',
      gap: 1,
      padding: '2px 6px',
      background: 'rgba(13,27,42,0.08)',
      borderRadius: 4,
      minWidth: 28,
      justifyContent: 'center',
    }}>
      <strong style={{ color: '#0A1428', fontWeight: 700 }}>{String(value).padStart(2, '0')}</strong>
      <span style={{ fontSize: 11, color: '#92400E' }}>{label}</span>
    </span>
  );
}

function getTimeLeft() {
  const total = Math.max(0, BETA_END_DATE.getTime() - Date.now());
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((total / (1000 * 60)) % 60);
  const seconds = Math.floor((total / 1000) % 60);
  return { total, days, hours, minutes, seconds };
}
